// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DigiLockerFailed_failedContainer__NPjwf {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  padding: 20px;
  background-color: #fff;
  width: 100%;
  box-sizing: border-box;
}

.DigiLockerFailed_failedImage__qbIn- {
  width: 120px;
  height: 120px;
  margin-bottom: 24px;
  animation: DigiLockerFailed_shake__da9aJ 0.5s ease-in-out;
  max-width: 100%;
  object-fit: contain;
}

@keyframes DigiLockerFailed_shake__da9aJ {
  0%, 100% { transform: translateX(0); }
  25% { transform: translateX(-10px); }
  75% { transform: translateX(10px); }
}

.DigiLockerFailed_title__hEV7G {
  font-size: 28px;
  color: #dc3545;
  margin-bottom: 16px;
  font-weight: 600;
}

.DigiLockerFailed_message__4ueU9 {
  font-size: 18px;
  color: #6c757d;
  text-align: center;
  margin-bottom: 24px;
  max-width: 400px;
  line-height: 1.5;
}

.DigiLockerFailed_countdown__qHXeV {
  font-size: 16px;
  color: #495057;
  margin-top: 8px;
  font-weight: 500;
}

.DigiLockerFailed_redirectText__QOTww {
  color: #6c757d;
  font-size: 14px;
  margin-top: 16px;
}

@media screen and (max-width: 768px) {
  .DigiLockerFailed_failedContainer__NPjwf {
    padding: 15px;
  }

  .DigiLockerFailed_failedImage__qbIn- {
    width: 100px;
    height: 100px;
    margin-bottom: 20px;
  }

  .DigiLockerFailed_title__hEV7G {
    font-size: 24px;
    margin-bottom: 12px;
  }

  .DigiLockerFailed_message__4ueU9 {
    font-size: 16px;
    margin-bottom: 20px;
    padding: 0 10px;
  }

  .DigiLockerFailed_countdown__qHXeV {
    font-size: 14px;
  }

  .DigiLockerFailed_redirectText__QOTww {
    font-size: 12px;
  }
}

@media screen and (max-width: 480px) {
  .DigiLockerFailed_failedContainer__NPjwf {
    padding: 10px;
  }

  .DigiLockerFailed_failedImage__qbIn- {
    width: 80px;
    height: 80px;
    margin-bottom: 16px;
  }

  .DigiLockerFailed_title__hEV7G {
    font-size: 20px;
    margin-bottom: 10px;
  }

  .DigiLockerFailed_message__4ueU9 {
    font-size: 14px;
    margin-bottom: 16px;
  }

  .DigiLockerFailed_countdown__qHXeV {
    font-size: 12px;
  }

  .DigiLockerFailed_redirectText__QOTww {
    font-size: 11px;
    margin-top: 12px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/organism/DigiLockerFailed.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,yDAAiC;EACjC,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,WAAW,wBAAwB,EAAE;EACrC,MAAM,4BAA4B,EAAE;EACpC,MAAM,2BAA2B,EAAE;AACrC;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,YAAY;IACZ,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;AACF","sourcesContent":[".failedContainer {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  min-height: 100vh;\n  padding: 20px;\n  background-color: #fff;\n  width: 100%;\n  box-sizing: border-box;\n}\n\n.failedImage {\n  width: 120px;\n  height: 120px;\n  margin-bottom: 24px;\n  animation: shake 0.5s ease-in-out;\n  max-width: 100%;\n  object-fit: contain;\n}\n\n@keyframes shake {\n  0%, 100% { transform: translateX(0); }\n  25% { transform: translateX(-10px); }\n  75% { transform: translateX(10px); }\n}\n\n.title {\n  font-size: 28px;\n  color: #dc3545;\n  margin-bottom: 16px;\n  font-weight: 600;\n}\n\n.message {\n  font-size: 18px;\n  color: #6c757d;\n  text-align: center;\n  margin-bottom: 24px;\n  max-width: 400px;\n  line-height: 1.5;\n}\n\n.countdown {\n  font-size: 16px;\n  color: #495057;\n  margin-top: 8px;\n  font-weight: 500;\n}\n\n.redirectText {\n  color: #6c757d;\n  font-size: 14px;\n  margin-top: 16px;\n}\n\n@media screen and (max-width: 768px) {\n  .failedContainer {\n    padding: 15px;\n  }\n\n  .failedImage {\n    width: 100px;\n    height: 100px;\n    margin-bottom: 20px;\n  }\n\n  .title {\n    font-size: 24px;\n    margin-bottom: 12px;\n  }\n\n  .message {\n    font-size: 16px;\n    margin-bottom: 20px;\n    padding: 0 10px;\n  }\n\n  .countdown {\n    font-size: 14px;\n  }\n\n  .redirectText {\n    font-size: 12px;\n  }\n}\n\n@media screen and (max-width: 480px) {\n  .failedContainer {\n    padding: 10px;\n  }\n\n  .failedImage {\n    width: 80px;\n    height: 80px;\n    margin-bottom: 16px;\n  }\n\n  .title {\n    font-size: 20px;\n    margin-bottom: 10px;\n  }\n\n  .message {\n    font-size: 14px;\n    margin-bottom: 16px;\n  }\n\n  .countdown {\n    font-size: 12px;\n  }\n\n  .redirectText {\n    font-size: 11px;\n    margin-top: 12px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"failedContainer": `DigiLockerFailed_failedContainer__NPjwf`,
	"failedImage": `DigiLockerFailed_failedImage__qbIn-`,
	"shake": `DigiLockerFailed_shake__da9aJ`,
	"title": `DigiLockerFailed_title__hEV7G`,
	"message": `DigiLockerFailed_message__4ueU9`,
	"countdown": `DigiLockerFailed_countdown__qHXeV`,
	"redirectText": `DigiLockerFailed_redirectText__QOTww`
};
export default ___CSS_LOADER_EXPORT___;
